export default (config = {}, selected) => {
    config.options = config.options.map((option) => {
        return {
            [config.trackBy]: String(option[config.trackBy]),
            [config.label]: String(option[config.label])
        };
    });

    return {
        model: selected,
        options: config.options,
        trackBy: config.trackBy,
        label: config.label,
        readonly: config.readonly,
        placeholder: config.placeholder,

        search: null,
        isOpen: false,

        get filteredOptions() {
            if (this.search) {
                let search = this.search.toLowerCase();

                return this.options.filter((option) => {
                    return this.optionLabel(option).toLowerCase().includes(search);
                });
            }

            return this.options;
        },
        get selected() {
            return this.options.filter((option) => {
                return Array.isArray(this.model) ?
                    this.model.filter((selected) => selected == this.optionKey(option)).length > 0 :
                    false;
            });
        },
        get hasSelected() {
            return this.model.length > 0;
        },

        select(option) {
            if (!this.readonly) {
                this.model.push(this.optionKey(option));
            }
        },
        isSelected(option) {
            return this.model.includes(this.optionKey(option));
        },
        remove(option) {
            if (!this.readonly) {
                this.model = this.model.filter((item) => item != this.optionKey(option));
            }
        },
        empty() {
            if (!this.readonly) {
                this.model = [];
            }
        },

        openOptions() {
            if (!this.readonly) {
                this.isOpen = true;
                this.$refs.searchField.focus();
            }
        },
        closeOptions() {
            if (!this.readonly) {
                this.isOpen = false;
                this.search = null;
            }
        },

        optionLabel(option) {
            return option[this.label];
        },
        optionKey(option) {
            return option[this.trackBy];
        }
    };
}